import { render, staticRenderFns } from "./PopupProductDetail.vue?vue&type=template&id=338ea922&scoped=true&"
import script from "./PopupProductDetail.vue?vue&type=script&lang=js&"
export * from "./PopupProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./PopupProductDetail.vue?vue&type=style&index=0&id=338ea922&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338ea922",
  null
  
)

export default component.exports